import React, { Suspense } from 'react';
import Loading from '../global/loading';
import Button from '../ui/button';
import LazyBackground from '../ui/lazyBackground';
import * as style from './bottomCallouts.module.scss';

const isSSR = typeof window === "undefined";

const ItemCallout = props => (
  <>
  {!isSSR && (
  <Suspense fallback={<Loading/>}>
    <div className={style.callout}>
      <div className={style.contentWrap}>
        <div className={`text-block`}>
          <div>{/* MISSING_CLASS_NAME: className={style.textInner} */}
            <div className={`reveal fadeInBlur reveal-delay-500`}>
              {props.calloutSubtitle && (
                <div className={style.textSubtitle}>{props.calloutSubtitle}</div>
              )}
              <div className={`typeFonts1 ${style.textHeading}`}>
                <h2>{props.calloutHeading}</h2>
              </div>
              <span className={style.textLine} />
              {props.cta_link && (
                <div className={style.textButton}>
                  <Button
                    color="white"
                    to={props.cta_link.url}
                    text={props.cta_link.title}
                    target={props.cta_link.target}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {props.src && (
        <div className={style.imageWrap}>
          <div className={style.imgTransformer}>
            <div className={`reveal fadeIn ${style.revealContainer}`}>
              <LazyBackground
                hasRevealer={props.hasRevealer}
                revealed={props.revealed}
                src={props.src}
                opacity={props.opacity ? props.opacity : 0.35}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  </Suspense>
  )}
  </>
);

const BottomCallouts = props => {
  const itemCallouts =
    props.itemCallouts &&
    props.itemCallouts.map((item, i) => (
      <ItemCallout
        {...item}
        key={`item${i}`}
        hasRevealer={props.hasRevealer}
        revealed={props.revealed}
      />
    ));
  return (
    <div className={`container-component ${style.bottomCallouts}`}>
      {itemCallouts}
    </div>
  );
};

export default BottomCallouts;
